
export const KeepAliveClick = (new_frequency, inheritance_parameters) =>{
    const next_notification = Date.now()+Number(new_frequency)
    const new_inheritance_parameters={...inheritance_parameters,
        "keep_alive_frequency":new_frequency,
        "next_notification":next_notification,
        "sent_notifications":0,
        "dday_priority_one":next_notification+inheritance_parameters.priority_one_delay,
        "dday_priority_two":next_notification+inheritance_parameters.priority_one_delay+inheritance_parameters.priority_two_delay,
        "self_recovery_day":next_notification+inheritance_parameters.self_recovery
    }
    return new_inheritance_parameters
}
// export const KeepAliveClick = (keep_alive_timeout, inheritance_parameters) =>{
//     const next_notification = Date.now()+Number(keep_alive_timeout)
//     const new_inheritance_parameters={...inheritance_parameters,
//         "keep_alive_frequency":keep_alive_timeout,
//         "next_notification":next_notification,
//         "sent_notifications":0,
//         "dday_priority_one":next_notification+inheritance_parameters.priority_one_delay,
//         "dday_priority_two":next_notification+inheritance_parameters.priority_one_delay+inheritance_parameters.priority_two_delay,
//         "self_recovery_day":next_notification+inheritance_parameters.self_recovery
//     }
//     return new_inheritance_parameters
// }
export const updateDelays = (priority, new_delay, UserData)=>{
    if (priority==="one"){
        return {...UserData, 
            "inheritance_parameters":{...UserData.inheritance_parameters, 
            "priority_one_delay":new_delay,
            "dday_priority_one":Number(UserData.inheritance_parameters.next_notification)+new_delay,
            "dday_priority_two":Number(UserData.inheritance_parameters.next_notification)+new_delay+Number(UserData.inheritance_parameters.priority_two_delay)
        }}
    }else{
        return {...UserData, 
            "inheritance_parameters":{...UserData.inheritance_parameters, 
            "priority_two_delay":new_delay,
            "dday_priority_two":Number(UserData.inheritance_parameters.dday_priority_one)+new_delay
        }}
    }
}
export const updateSelfRecovery = (UserData, delay)=>{
    return {...UserData, 
        "inheritance_parameters":{...UserData.inheritance_parameters,
        "self_recovery":delay,
        "self_recovery_day":UserData.inheritance_parameters.next_notification+Number(delay)
        }}

}